const AppGuard = (to, _, next) => {
    document.title = to.meta.title ?? "The Hindu BusinessLine ePaper | Latest Business News and Financial Updates"
    const auth = window.tp?.pianoId?.isUserValid()
    if (!auth && to.meta.auth) next('/reader')
    else next()
}

const WebViewGuard = (to, _, next) => {
    if (to.query.apptoken)
        try {
            window.tp.pianoId.loginByToken(to.query.apptoken)
            return next()
        } catch (error) {
            console.log(error);
        }
    return next()
}

export { AppGuard, WebViewGuard }